import { stringify } from 'qs';

const updatePageNumber = query => {
  const addQuery = query ? "?".concat(stringify(query)) : '';

  if (window.history.pushState) {
    const path = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(addQuery);
    window.history.replaceState({
      path
    }, '', path);
  }
};

export default updatePageNumber;